import React from 'react'

import { Dialog } from 'primereact/dialog'
import ProductService from '../../app/service/productService'
import DialogFooter from '../dialogFooter'
import InputChooseFornecedor from '../contasAPagar/inputChooseFornecedor'
import ConstantsUtil from '../../context/constantsUtil'
import GeneralServices from '../../app/service/generalServices'
import BuyProductService from '../../app/service/buyProductService'
import HandleErrorService from '../../app/service/handleErrorService'
import * as popUp from '../toastr'
import InputChooseTipoProduto from './tipoProduto/inputChooseTipoProduto'
import CadastroProdutoService from '../../app/service/central/cadastroProdutoService'
import AuthService from '../../app/service/authService'

class ProductDialog extends React.Component {

    state = {
        codigo: null,
        inputCodigoErrorClass: '',
        errorCodigoMessage: '',
        
        descricao: '',
        inputDescricaoErrorClass: '',
        errorDescricaoMessage: '',
        
        quantidade: null,
        
        ncm: null,
        inputNCMErrorClass: '',
        errorNCMMessage: '',
        
        cfop: null,
        inputCFOPErrorClass: '',
        errorCFOPMessage: '',
        
        tipo: {},
        inputTipoErrorClass: '',
        errorTipoMessage: '',

        tipoEstoque: {},
        inputTipoEstoqueErrorClass: '',
        errorTipoEstoqueMessage: '',
        
        unidadeComercializada: '',
        inputUnidadeErrorClass: '',
        errorUnidadeMessage: '',
        
        proporcao: null,
        didUpdated: false,
        // visibleConfirmDialog: false,

        fornecedor: {},
        inputFornecedorErrorClass: '',
        visible: true,
    }

    constructor(){
        super();
        this.productService = new ProductService();
        this.buyProductService = new BuyProductService();
        this.cadastroProdutoService = new CadastroProdutoService();
        
    }

    componentDidMount(){
        // console.log("componentDidMount")
        this.setStates()
    }

    componentDidUpdate(){
        // console.log("componentDidUpdate")
        this.setStates()
    }

    setStates = () => {
        if( (this.props.visible && !this.state.didUpdated) || this.props.forceUpdate ){
            // console.log("setStates")
            if(this.props.state){
                this.setState({codigo: this.props.state.codigo})
                this.setState({descricao: this.props.state.descricao})
                this.setState({ncm: this.props.state.ncm})
                this.setState({cfop: this.props.state.cfop})
                this.setState({tipo: this.props.state.tipo})
                this.setState({tipoEstoque: this.props.state.tipoEstoque})
                this.setState({unidadeComercializada: this.props.state.unidadeComercializada})
                this.setState({proporcao: this.props.state.proporcao})
            }

            if(this.props.fornecedor){
                this.setState({fornecedor: this.props.fornecedor})
            }

            this.resetView()
            
            this.setState({didUpdated: true})
            if(this.props.doneForceUpdate){
                this.props.doneForceUpdate()
            }
        }
    }

    resetView = () => {
        this.setState({inputCodigoErrorClass: ''})
        this.setState({errorCodigoMessage: ''})
        this.setState({inputDescricaoErrorClass: ''})
        this.setState({errorDescricaoMessage: ''})
        this.setState({inputNCMErrorClass: ''})
        this.setState({errorNCMMessage: ''})
        this.setState({inputCFOPErrorClass: ''})
        this.setState({errorCFOPMessage: ''})
        this.setState({inputTipoErrorClass: ''})
        this.setState({errorTipoMessage: ''})
        this.setState({inputTipoEstoqueErrorClass: ''})
        this.setState({inputUnidadeErrorClass: ''})
        this.setState({errorUnidadeMessage: ''})

        this.setState({inputFornecedorErrorClass: ''})
    }

    handleChange = (event) => {
        const value = event.target.value
        const name = event.target.name
        this.setState({ [name]: value })
    }

    handleTipoProdutoChange = (selectedTipoProduto, attribute) => {
        // console.log("selectedTipoProduto: ", selectedTipoProduto)
        // console.log("attribute: ", attribute)

        switch(attribute){
            
            case ConstantsUtil.inputTipoProduto:
                this.setState({tipo: selectedTipoProduto})
                break
                
            case ConstantsUtil.inputTipoEstoque:
                this.setState({tipoEstoque: selectedTipoProduto})
                break
        
        }

    }

    // handleTipoProdutoChange = (index, selectedTipoProduto, attribute) => {

    //     let transactionList = this.state.transactions
    //     let transaction = transactionList[index]
    //     transaction[attribute] = selectedTipoProduto
        
    //     this.state.transactions.forEach(transaction => {
    //         if(!transaction[attribute]){
    //             transaction[attribute] = selectedTipoProduto
    //         }
    //     })
    //     this.setState({transactions: transactionList})
    // }    

    hideDialog = (clearData) => {
        this.setState({didUpdated: false})
        if(clearData){
            this.props.hideDialog()
        }
        else{
            this.setState({visible: false})
        }

    }

    checkData = () => {
        var check = true
        if(!this.props.isProdutoCompra && !this.state.codigo){
            this.setState({inputCodigoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            this.setState({errorCodigoMessage:"Código é obrigatório"})
            check = false
        }
        if(!this.state.descricao){
            this.setState({inputDescricaoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            this.setState({errorDescricaoMessage:"Nome é obrigatório"})
            check = false
        }
        if(!this.props.isProdutoCompra && !this.state.ncm && this.state.ncm!==0){
            this.setState({inputNCMErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            this.setState({errorNCMMessage:"NCM é obrigatório"})
            check = false
        }
        if(!this.props.isProdutoCompra && !this.state.cfop && this.state.cfop!==0){
            this.setState({inputCFOPErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            this.setState({errorCFOPMessage:"CFOP é obrigatório"})
            check = false
        }
        if(!this.state.tipo || !this.state.tipo.descricao){
            this.setState({inputTipoErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            this.setState({errorTipoMessage:"Tipo de Produto é obrigatório"})
            check = false
        }

        if(!this.state.tipoEstoque || !this.state.tipoEstoque.descricao){
            this.setState({inputTipoEstoqueErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            this.setState({errorTipoEstoqueMessage:"Tipo de Estoque é obrigatório"})
            check = false
        }

        if(!this.state.unidadeComercializada){
            this.setState({inputUnidadeErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            this.setState({errorUnidadeMessage:"Unidade é obrigatória"})
            check = false
        }
        
        if(this.props.isProdutoCompra && GeneralServices.isEmptyObject(this.state.fornecedor)){
            this.setState({inputFornecedorErrorClass: ConstantsUtil.bootstrapInputErrorClass})
            check = false
        }

        return check
    }

    callSave = () => {
        this.resetView()
        if(this.checkData()){
            // this.setState({visibleConfirmDialog: true})
            this.save()
        }
    }

    // hideConfirmDialog = () => {
    //     this.setState({visibleConfirmDialog: false})
    // }

    save = () => {
        if(this.props.isProdutoCompra){
            this.saveProdutoCompra()
        }
        else{
            this.saveProdutoVenda()
        }
        this.setState({didUpdated: false})
        // this.setState({visibleConfirmDialog: false})
    }

    handleSaveProdutoCompra = (produtoCompra) => {
        if(this.props.isEditProdutoCompra){
            return this.cadastroProdutoService.editBuyProduct(produtoCompra)
        }
        else{
            return this.buyProductService.save(produtoCompra)
        }
    }

    saveProdutoCompra = () => {

        this.hideDialog(false)

        const produtoCompra = {
            codigo: this.state.codigo,
            descricao: this.state.descricao,
            tipoProduto: this.state.tipo,
            tipoEstoque: this.state.tipoEstoque,
            unidadeComercializada: this.state.unidadeComercializada,
            cnpjFornecedor: this.state.fornecedor.cnpj,
        }
        // console.log("produtoCompra: ", produtoCompra)
        // this.buyProductService.save(produtoCompra)
        AuthService.startBlockUi()
        this.handleSaveProdutoCompra(produtoCompra)
        .then(response => {
            popUp.successPopUp(`Produto de Compra ${this.props.isEditProdutoCompra ? "alterado" : "cadastrado"} com Sucesso!`)
            this.hideDialog(true)
            if(this.props.search){
                this.props.search()
            }
        })
        .catch(error => {
            HandleErrorService.handleError(error)
            this.setState({visible: true})
        })
        .finally(() => {
            AuthService.stopBlockUi()
        })
    }

    saveProdutoVenda = () => {
        var {codigo, descricao, ncm, cfop, tipo, tipoEstoque, unidadeComercializada} = this.state
        this.props.saveProdutoVenda({codigo, descricao, ncm, cfop, tipoProduto: tipo, tipoEstoque, unidadeComercializada})
        this.setState({didUpdated: false})        
     }

    render () {

        const renderCodigoInput = () => {
            if(!this.props.isProdutoCompra){
                return(
                    <div className="p-field">
                    <label htmlFor="codigo">Código</label>
                    <input style={{color: '#000'}} 
                        type="number"
                        className={"form-control " + this.state.inputCodigoErrorClass}
                        value = {this.state.codigo}
                        name="codigo"
                        onChange={this.handleChange}
                        id="inputCodigo"
                        placeholder="Digite o código"
                        disabled={this.props.disabled} 
                    />
                    <div className="invalid-feedback">{this.state.errorCodigoMessage}</div>
                    <br />
                </div>
                )
            }
        }

        const renderNCMInput = () => {
            if(!this.props.isProdutoCompra){
                return(
                    <>
                    <div className="p-field">
                        <label htmlFor="ncm">NCM</label>
                        <input style={{color: '#000'}} type="number"
                                className={"form-control " + this.state.inputNCMErrorClass}
                                value = {this.state.ncm}
                                name="ncm"
                                onChange={this.handleChange}
                                id="inputNCM"
                                placeholder="Digite o NCM"
                                disabled={this.props.disabled}  
                                />
                        <div className="invalid-feedback">{this.state.errorNCMMessage}</div>
                    </div>
                    <br/>                    
                    </>
                )
           }
        }

        const renderCFOPnput = () => {
            if(!this.props.isProdutoCompra){
                return(
                    <>
                    <div className="p-field">
                        <label htmlFor="cfop">CFOP</label>
                        <input style={{color: '#000'}} type="number"
                                className={"form-control " + this.state.inputCFOPErrorClass}
                                value = {this.state.cfop}
                                name="cfop"
                                onChange={this.handleChange}
                                id="inputCFOP"
                                placeholder="Digite o CFOP"
                                disabled={this.props.disabled}  
                                />
                        <div className="invalid-feedback">{this.state.errorCFOPMessage}</div>
                    </div>
                    <br/>                    
                    </>
                )
            }
        }

        const renderFornecedorInput = () => {
            if(this.props.isProdutoCompra){
                return (
                    // <div className = "col-md-3">
                    <div >
                        <InputChooseFornecedor
                            noHTMLFormat
                            selectedFornecedorLabel={this.state.fornecedor.nome}
                            handleSelectionFornecedorChange={(fornecedor) => this.setState({fornecedor})}
                            inputFornecedorErrorClass={this.state.inputFornecedorErrorClass}
                            disabled={this.props.isEditProdutoCompra}
                        />

                        <br />

                    </div>
                )
            }
        }        


        const productDialogFooter = (
            <DialogFooter save = {this.callSave} hideDialog = {() => this.hideDialog(true)} disabled={this.props.disabled} />
        )

        return (
            <>
            <Dialog
                visible={this.props.visible && this.state.visible}
                style={{ width: '450px' }}
                header={this.props.header}
                modal
                className="p-fluid"
                footer={productDialogFooter}
                onHide={() => this.hideDialog(true)}
            >

                {renderCodigoInput()}

                {renderNCMInput()}

                {renderCFOPnput()}

                <div className="p-field">
                    <label htmlFor="description">{ConstantsUtil.nomeProdutoLabel}</label>
                    <input
                        className={"form-control " + this.state.inputDescricaoErrorClass}
                        id="description"
                        name="descricao"
                        value={this.state.descricao}
                        placeholder="Digite o nome"
                        onChange = {this.handleChange}
                        disabled={this.props.disabled} 
                    />
                    <div className="invalid-feedback">{this.state.errorDescricaoMessage}</div>
                </div>
                <br />

                {renderFornecedorInput()}                         

                <div className="p-field">
                    <InputChooseTipoProduto
                        tipo={ConstantsUtil.inputTipoProduto}
                        noHTMLFormat
                        selectedTipoProdutoLabel={this.state.tipo ? this.state.tipo.descricao : ''}
                        handleSelectionChange={(selectedTipoProduto) => this.handleTipoProdutoChange(selectedTipoProduto, ConstantsUtil.inputTipoProduto)}
                        disabled={this.props.disabled} 
                        inputErrorClass={this.state.inputTipoErrorClass}
                    />
                </div>

                <br />

                <div className="p-field">
                    <InputChooseTipoProduto
                        tipo={ConstantsUtil.inputTipoEstoque}
                        noHTMLFormat
                        selectedTipoProdutoLabel={this.state.tipoEstoque ? this.state.tipoEstoque.descricao : ''}
                        handleSelectionChange={(selectedTipoProduto) => this.handleTipoProdutoChange(selectedTipoProduto, ConstantsUtil.inputTipoEstoque)}
                        disabled={this.props.disabled} 
                        inputErrorClass={this.state.inputTipoEstoqueErrorClass}
                    />
                </div>
                
                <br/>

                <div className="p-field">
                    <label htmlFor="status">Unidade</label>
                    <input style={{color: '#000'}} type="text"
                                    className={"form-control " + this.state.inputUnidadeErrorClass}
                                    value = {this.state.unidadeComercializada}
                                    name="unidadeComercializada"
                                    onChange={this.handleChange}
                                    id="inputUnidade"
                                    placeholder="Digite a unidade"
                                    disabled={this.props.disabled} 
                                    />
                    <div className="invalid-feedback">{this.state.errorUnidadeMessage}</div>
                </div>

            </Dialog>
            
            {/* <ConfirmationDialog
                header={ this.props.register ? "Cadastrar produto" : "Editar produto"}
                confimationMessage={ this.props.register ? "Confirmar cadastro do produto?" : "Confirmar modificação no produto?"}
                visible={this.state.visibleConfirmDialog && this.props.visible}
                confirm={this.save}
                hide={this.hideConfirmDialog}
            /> */}

            </>

        )
    }
}

export default ProductDialog